import { z } from "zod";
import { searchArtistSchema } from "./artist";
import { searchAlbumSchema } from "@libs/catalog-engine-contracts/album";
import { searchSongSchema } from "@libs/catalog-engine-contracts/song";
import { searchPlaylistSchema } from "./playlist";

export const searchSchema = z.discriminatedUnion("type", [
  searchArtistSchema,
  searchAlbumSchema,
  searchSongSchema,
  searchPlaylistSchema,
]);

export type Search = z.infer<typeof searchSchema>;

/**
 * Wire shape of `user.listRecentSearches`. Co-located with the procedure
 * so the client durable-cache layer
 * (`apps/mobile/hooks/trpc/useSearch/queryFunctions.ts`) can parse cached
 * rows on read. A drift assertion in that file binds the schema to the
 * tRPC return type at compile time.
 */
export const recentSearchesListSchema = z.array(searchSchema);

export type RecentSearchesList = z.infer<typeof recentSearchesListSchema>;

export const recentSearchesPaginatedSchema = z.object({
  data: recentSearchesListSchema,
  nextCursor: z.number().optional(),
});

export type RecentSearchesPaginated = z.infer<
  typeof recentSearchesPaginatedSchema
>;
